<script setup lang="ts">
import { useGoogleAnalyticsPageView } from '~/composables/google-analytics'
import ContactForm from '~/components/forms/ContactForm.vue'

const { $seoManager } = useNuxtApp()

const seo = $seoManager.generateSeoInfo({
  title: 'Contact',
})
useHead(seo)
useGoogleAnalyticsPageView(seo.title)
</script>

<template>
  <div class="relative h-full grow justify-center">
    <!-- Cover -->
    <section
      class="left-0 top-0 h-40 bg-s-400 bg-cover bg-top md:absolute md:h-full md:w-1/2 md:pb-0"
      style="
        background-image: url('https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto/v1672543746/source-assets/contact_avukbo.avif?_i=AA');
      "
    />

    <!-- Form -->
    <section
      class="mx-auto max-w-content-container justify-end pb-48 pt-8 md:flex lg:pb-48 lg:pt-24"
    >
      <div class="flex min-h-[450px] justify-center px-8 md:w-1/2 md:px-11">
        <ContactForm class="fill-max-width mx-auto max-w-[400px]" />
      </div>
    </section>
  </div>
</template>
